import i18n from '@/i18n';

const UNIT_I18N_KEYS: Record<string, string> = {
  milliontoken: 'home:millionToken',
};

/** 数量单位本地化（插件内自用，禁止依赖 pages） */
export function formatQuantityUnit(unit?: string, lang?: string): string {
  if (!unit) return '';
  const normalized = unit.toLowerCase();
  const i18nKey = UNIT_I18N_KEYS[normalized];
  if (i18nKey) {
    return i18n.t(i18nKey);
  }
  return lang === 'zh-cn' ? unit : unit;
}
